import { PointeauType } from 'src/app/app.constants';
import { Nommable } from '../nommable.model';

export class Pointeau extends Nommable {
  constructor(
    id: string,
    libelle: string,
    public description: string,
    public payload: string,
    public type = PointeauType.QRCODE,
    public reponseAttendue: string
  ) {
    super(id, libelle);
  }

  public static hydrate(obj: Pointeau): Pointeau {
    return new Pointeau(obj.id, obj.libelle, obj.description, obj.payload, obj.type ?? PointeauType.QRCODE, obj.reponseAttendue);
  }

  public clone(): Pointeau {
    return Pointeau.hydrate(this);
  }

  public extend(other: Pointeau): void {
    this.id = other.id;
    this.libelle = other.libelle;
    this.description = other.description;
    this.payload = other.payload;
    this.type = other.type;
    this.reponseAttendue = other.reponseAttendue;
  }
}
